@use 'kci-design-lib/styles/variables.scss' as *;
.radio-button-container {
  display: block;
  color: var(--checkbox-radio-text);
  &.small {
    line-height: 20px;
    font-size: 14px;
    input {
      height: 20px;
      width: 20px; 
      position: relative;
      margin: 0 8px 0 0;
      color: var(--checkbox-radio-text);
      line-height: 20px;
    }
    &.hover {
      input[type='radio'] {
        &:checked {
          &:disabled {
            background: url('../../../assets/rb-default-dis-20.svg') 0px 0px
              no-repeat;
            border: 0px;
            cursor: not-allowed;
          }
        }
      }
    }
    .radio-button {
      width: 20px;
      height: 20px;
      margin-right: 8px;
      &:has(input[type='radio']:focus) {
        &::before {
          background-image: url('../../../assets/rb-hover-20.svg');
        }
        &[data-p-checked='true'] {
          &::before {
            background-image: url('../../../assets/rb-selected-20.svg');
          }
        }
      }
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        background-image: url('../../../assets/rb-default-20.svg');
        background-repeat: no-repeat;
        background-size: 20px 20px;
        height: 20px;
        width: 20px;
      }
      &[data-p-checked='true'] {
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background-image: url('../../../assets/rb-selected-20.svg');
          background-repeat: no-repeat;
          background-size: 20px 20px;
          height: 20px;
          width: 20px;
        }
        &:has([disabled]) {
          &::before {
            content: '';
            display: inline-block;
            position: absolute;
            background-image: url('../../../assets/rb-selected-dis-20.svg');
            background-repeat: no-repeat;
            background-size: 20px 20px;
            height: 20px;
            width: 20px;
          }
        }
      }
      &:has([disabled]) {
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background-image: url('../../../assets/rb-default-dis-20.svg');
          background-repeat: no-repeat;
          background-size: 20px 20px;
          height: 20px;
          width: 20px;
        }
      }
    }
  }
  &.large {
    line-height: 24px;
    font-size: 16px;
    input {
      height: 24px;
      width: 24px; 
      position: relative;
      margin: 0 12px 0 0;
      color: var(--checkbox-radio-text);
      line-height: 24px;
    }
    &.hover {
      input[type='radio'] {
        &:checked {
          &:disabled {
            background: url('../../../assets/rb-default-dis-24.svg') 0px 0px
              no-repeat;
            border: 0px;
            cursor: not-allowed;
          }
        }
      }
    }
    .radio-button {
      width: 24px;
      height: 24px;
      margin-right: 12px;
      &:has(input[type='radio']:focus) {
        &::before {
          background-image: url('../../../assets/rb-hover-24.svg');
        }
        &[data-p-checked='true'] {
          &::before {
            background-image: url('../../../assets/rb-selected-24.svg');
          }
        }
      }
      &::before {
        content: '';
        display: inline-block;
        position: absolute;
        background-image: url('../../../assets/rb-default-24.svg');
        background-repeat: no-repeat;
        background-size: 24px 24px;
        height: 24px;
        width: 24px;
      }
      &[data-p-checked='true'] {
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background-image: url('../../../assets/rb-selected-24.svg');
          background-repeat: no-repeat;
          background-size: 24px 24px;
          height: 24px;
          width: 24px;
        }
        &:has([disabled]) {
          &::before {
            content: '';
            display: inline-block;
            position: absolute;
            background-image: url('../../../assets/rb-selected-dis-24.svg');
            background-repeat: no-repeat;
            background-size: 24px 24px;
            height: 24px;
            width: 24px;
          }
        }
      }
      &:has([disabled]) {
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background-image: url('../../../assets/rb-default-dis-24.svg');
          background-repeat: no-repeat;
          background-size: 24px 24px;
          height: 24px;
          width: 24px;
        }
      }
    }
  }
  input[type='radio'] {
    border-radius: 2px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    position: relative;
  }
  &:has([disabled]) {
    color: $pbl-text-dsbl;
  }
  [data-pc-name='radiobutton'] {
    opacity: 1;
  }
}
[data-pc-section='box'] {
  display: none;
}
